import { render, staticRenderFns } from "./TripsPage.vue?vue&type=template&id=c56c8d4a"
import script from "./TripsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TripsPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports